export default require('../../client/birth/CheckoutPage').default;
